<template>
    <o-form-group
        :id="this_id"
        :form-state="formState"
        :label="label"
        :message="errorMessages"
        :nolabel="nolabel"
        :type="{ 'is-danger': hasError }"
    >
        <BInputGroup v-if="is_locked">
            <BFormInput
                :id="this_id"
                :class="input_class"
                class="readonly_field"
                disabled
                type="text"
                v-bind="$attrs"
                :value="value"
            >
            </BFormInput>

            <template #append>
                <BButton variant="outline-secondary" @click="unlock">
                    <lock-icon />
                </BButton>
            </template>
        </BInputGroup>

        <BInputGroup v-if="!is_locked">
            <BFormInput
                :id="this_id"
                :class="input_class"
                :disabled="_is_readonly"
                type="text"
                v-bind="$attrs"
                :value="value"
                v-on="inputListeners"
            >
            </BFormInput>
        </BInputGroup>

        <span v-if="formState.debug">
            SE:{{ serverErrors }} [{{ serverErrorsIndex }}].{{ name }}<br />
            AL_SE:{{ all_server_errors }}
        </span>
    </o-form-group>
</template>

<script>
import { BButton, BFormInput, BInputGroup } from "bootstrap-vue";
import FormComponentMixin from "../../../mixins/form_component_mixin.js";

import LockIcon from "vue-material-design-icons/Lock.vue";

import OFormGroup from "../OFormGroup.vue";

export default {
    name: "OCodeEdit",
    components: {
        BInputGroup,
        BButton,
        BFormInput,
        OFormGroup,
        LockIcon,
    },
    mixins: [FormComponentMixin],
    props: {
        create: { type: Boolean, default: false },
    },
    data() {
        return {
            unlocked: false,
            initial_value_captured: false,
            had_value_on_load: false,
        };
    },
    computed: {
        should_disable() {
            return this.had_value_on_load && !this.create;
        },
        is_locked() {
            if (this.unlocked) {
                return false;
            }
            return this.should_disable;
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                if (!this.initial_value_captured && val != null) {
                    this.initial_value_captured = true;
                    this.had_value_on_load = val !== "";
                }
            },
        },
    },
    methods: {
        unlock() {
            this.unlocked = true;
        },
    },
};
</script>

<style scoped></style>
